import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/team.jpg";
import "../Profiles/Profile.css"; // Using the common Profile CSS
import Breadcrumb from "react-bootstrap/Breadcrumb";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import XIcon from "@mui/icons-material/X"; // Standardized X icon
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import Card7 from "../Images/Profiles/Hasifa.jpg";
import "../Pages/NewsandEvents.css"; // ← reuse styles for hero and breadcrumb

function HasifaNamugabo() {
  return (
    <div className="ne-page">
      <SEO
        title="Ms. Hasifa Namugabo - Welfare Officer"
        description="Ms. Hasifa Namugabo is a Welfare Officer at CIRCODU with a secondary education certificate and a cosmetology certificate."
        keywords="Hasifa Namugabo, Welfare Officer, CIRCODU, secondary education certificate, cosmetology certificate"
        url="/hasifa-namugabo"
        image={Card7}
        type="profile"
      />

      {/* ── Hero banner ─────────────────────────────── */}
      <div className="ne-hero">
        <div className="ne-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="ne-hero__overlay">
          <h4 className="ne-hero__title">Ms. Hasifa Namugabo</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">The Team</Breadcrumb.Item>
            <Breadcrumb.Item className="text1" href="/the-team/the-staff-team">
              The Staff Team
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Ms. Hasifa Namugabo
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      {/* ── Profile section ─────────────────────────── */}
      <section className="profile-section border-bottom">
        <div className="container">
          <div className="profile-card">
            {/* Green banner strip */}
            <div className="profile-card__banner" />

            {/* Photo + name/role */}
            <div className="profile-card__header">
              <div className="profile-card__photo-wrap">
                <img src={Card7} alt="Ms. Hasifa Namugabo" />
              </div>
              <div className="profile-card__identity">
                <h1 className="profile-card__name">Ms. Hasifa Namugabo</h1>
                <p className="profile-card__role">Welfare Officer</p>
              </div>
            </div>

            {/* Accent divider */}
            <div className="profile-card__divider" />

            {/* Biography */}
            <div className="profile-card__body">
              <div className="texty">
                <p>
                  Hasifa holds a secondary education certificate and has
                  obtained a cosmetology certificate from Tina School of Beauty.
                  She brings a wealth of experience in areas like sales,
                  marketing, business development, and management. Furthermore,
                  her entrepreneurial abilities are well-honed.
                </p>
                <p>
                  Hasifa is known for her enthusiasm and her eagerness to tackle
                  new challenges as a means of advancing her career and personal
                  growth. Her repertoire includes strong communication skills,
                  adeptness as a team player, excellent interpersonal abilities,
                  and a notable aptitude for quick learning.
                </p>
                <p>
                  In her current role, Hasifa serves as a Welfare Officer at the
                  Centre for Integrated Research and Community Development
                  Uganda (CIRCODU).
                </p>
              </div>
            </div>

            {/* Social links */}
            <div className="profile-card__socials">
              <a
                href="https://ug.linkedin.com/company/centre-for-integrated-research-and-community-development-uganda-circodu"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--linkedin"
                aria-label="LinkedIn"
              >
                <LinkedInIcon />
                <span>LinkedIn</span>
              </a>

              <a
                href="https://twitter.com/CIRCODU1"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--twitter"
                aria-label="X / Twitter"
              >
                <XIcon />
                <span>Twitter / X</span>
              </a>

              <a
                href="https://www.facebook.com/namugabo.hasifa/"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--facebook"
                aria-label="Facebook"
              >
                <FacebookOutlinedIcon />
                <span>Facebook</span>
              </a>

              <a
                href="https://wa.me/256703384157"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--whatsapp"
                aria-label="WhatsApp"
              >
                <WhatsAppIcon />
                <span>WhatsApp</span>
              </a>

              <a
                href="mailto:mercyhasifah@gmail.com"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--email"
                aria-label="Email"
              >
                <EmailIcon />
                <span>Email</span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default HasifaNamugabo;
